export default __webpack_public_path__ + "static/media/yt.07bd48b0.svg";